<template>

  <footer>

  	<div class="footer-contact container">
					<!-- CONTACT -->
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
            <p class="meta">ENQUIRIES</p>
						<a href="mailto:hello@tiny-square.design">
              <h3>hello@tiny-square.design</h3>
            </a>
            <p class="meta">FOLLOW ME</p>
            <a href="https://www.instagram.com/tiny_square_design/">
  						<h3>Instagram</h3>
            </a>
					</div>
  	</div>

    <div class="footer-notice  container">
      <!-- NOTICE AND LEGAL LINKS -->
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <p class="footer"><a class="footer" href="/terms-of-use" rel="external nofollow">Terms Of Use</a> / <a class="footer" href="/cookies" rel="external nofollow">Cookies</a> / <a class="footer" href="/privacy-policy" rel="external nofollow">Privacy Policy</a></p>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <p class="footer copyright">Copyright © Tiny Square Design Limited 2019</p>
          </div>
        </div>
      </div>
    </div>

  </footer>

</template>


<script>
export default {
  name: 'TsFooter'
}
</script>
